module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showHeader) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('div', {
    staticClass: "edo-progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: 100 - _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "edo-tree-icon",
    style: ({
      left: 'calc(' + _vm.progress + '% - 32px)'
    })
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/edo-tree-icon.svg"
    }
  })])]), _vm._v(" "), (_vm.showCounter) ? _c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.currentCounter,
      "autoplay": false,
      "duration": 7000
    },
    on: {
      "callbackCounter": _vm.updatePercentage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.counterTitle))])]) : _vm._e(), _vm._v(" "), (_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [(_vm.intro) ? _c('p', {
    staticClass: "form-intro"
  }, [_vm._v("\n          " + _vm._s(_vm.intro) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        edoEmailIsValid: true,
        email: true,
      }),
      expression: "{\n                required: true,\n                edoEmailIsValid: true,\n                email: true,\n              }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      }
    }
  }), _vm._v(" "), (_vm.emailCheckSensis.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("email")))]) : _vm._e()])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.postcode),
      expression: "lead.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "type": "number",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.lead.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        edoPhoneNumberIsValid: true
      }),
      expression: "{ required: true, edoPhoneNumberIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.message),
      expression: "lead.message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": "Your message. Writing a personalised message makes it harder for our politicians to ignore",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.lead.message)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('message')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "word-count"
  }, [_vm._v("\n            " + _vm._s(255 - (_vm.lead.message ? _vm.lead.message.length : 0) + " Char") + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "input-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptToUseMessage),
      expression: "acceptToUseMessage"
    }],
    attrs: {
      "id": "useMessage",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptToUseMessage) ? _vm._i(_vm.acceptToUseMessage, null) > -1 : (_vm.acceptToUseMessage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptToUseMessage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptToUseMessage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptToUseMessage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptToUseMessage = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useMessage"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.concentUseMessage) + "\n            ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('span', [_vm._v(_vm._s(_vm.submitButtonText))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "signatures-title"
  }, [_vm._v("Recent defenders")]), _vm._v(" "), _c('last-signatures', {
    attrs: {
      "campaignId": "edo",
      "numberOfSignatures": _vm.numberOfSignatures,
      "iconSource": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/edo-signature-icon.png",
      "classes": "edo-signatures",
      "action": "became a defender"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "privacy-statement"
  }, [(!_vm.isFromEDO) ? _c('p', [_vm._v("\n              By signing you accept\n              "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("\n                WWF-Australia’s Privacy Policy.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.isFromEDO) ? _c('p', [_vm._v("\n              By signing up to Defend the Unburnt Six you accept WWF’s project\n              partner EDO’s\n              "), _c('a', {
    attrs: {
      "href": "https://www.edo.org.au/privacy-policy/",
      "target": "_blank"
    }
  }, [_vm._v("\n                privacy policy\n              ")])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingMessage))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8d6b0aa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/forms/Edo.vue
// module id = 859
// module chunks = 0